import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { history } from '../../history';
import { EMSLogButton, S3DownloadButton } from './Buttons';
import RayPagination from './RayPagination';
import { isDIM, isDOA, isCon, isNEW } from './CommonViews';
import { CountryCode } from '../../config/CountryCode';
import { LanguageCode } from '../../config/LanguageCode';
import { Loading } from './Loading';
import { ServiceStatusChip } from '../service/ServiceCard';
import { InputDateFilter } from "./Inputs";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import RayTableExport from './RayTableExport';
// IMP-446: Export 버튼은 모달을 거쳐 handleExportClick 에서 직접 다운로드한다(ExportExcelClass 는 Exports.js 에 남아 다른 화면이 계속 쓴다).
import { exportWorkbook } from '../common/Exports';
import { Translate as t } from '../../config/Translate';
import { ListStateAction } from '../../actions/ListStateAction';
import { AlertAction } from '../../actions/AlertAction';
import ConfirmDialog from './ConfirmDialog';
import { visibleHeaderColumns } from '../../lib/headerPrefs';
import { formatDisplayDateTime, formatDisplayDate } from '../../lib/dateDisplay';
// IMP-446: 체크박스 선택 Export 경로에 컬럼 선택 모달을 끼운다. 후보/기본체크/선택결과 계산은
// exportColumns.js(SSoT)에 위임하고, 이 파일은 모달을 열고 확인 결과를 받아 다운로드만 실행한다.
import ExportColumnModal from './ExportColumnModal';
import { selectExportColumns } from '../../lib/exportColumns';

const POPUP_WIDTH = 200;
const POPUP_MAX_HEIGHT = 400;

// IMP-314: 필터 콤보 옵션 라벨 좌측 들여쓰기 상수. 네이티브 select 펼침 목록은 브라우저가
// 그려 CSS option padding 이 일부 환경(Chrome/Windows)에서 무시되어 라벨에 nbsp 를 직접 부여.
const FILTER_OPT_INDENT = '  ';

const ArrayLinkCell = ({ data, linkPath, maxShow, title }) => {
	const [showPopup, setShowPopup] = useState(false);
	const [pos, setPos] = useState({ x: 0, y: 0 });
	const popupRef = React.useRef(null);
	const listenersRef = React.useRef({ onMove: null, onUp: null });
	const displayData = data.slice(0, maxShow);
	const remaining = data.length - maxShow;

	const clampPos = (x, y) => ({
		x: Math.min(Math.max(0, x), window.innerWidth - POPUP_WIDTH),
		y: Math.min(Math.max(0, y), window.innerHeight - POPUP_MAX_HEIGHT)
	});

	const handleOpen = (e) => {
		e.stopPropagation();
		setPos(clampPos(e.clientX, e.clientY));
		setShowPopup(true);
	};

	const handleDragStart = React.useCallback((e) => {
		const startX = e.clientX, startY = e.clientY;
		const startPosX = pos.x, startPosY = pos.y;
		const onMove = (ev) => setPos(clampPos(startPosX + ev.clientX - startX, startPosY + ev.clientY - startY));
		const onUp = () => {
			document.removeEventListener('mousemove', onMove);
			document.removeEventListener('mouseup', onUp);
			listenersRef.current = { onMove: null, onUp: null };
		};
		listenersRef.current = { onMove, onUp };
		document.addEventListener('mousemove', onMove);
		document.addEventListener('mouseup', onUp);
	}, [pos]);

	// 드래그 리스너 cleanup
	useEffect(() => {
		return () => {
			const { onMove, onUp } = listenersRef.current;
			if (onMove) document.removeEventListener('mousemove', onMove);
			if (onUp) document.removeEventListener('mouseup', onUp);
		};
	}, []);

	// 팝업 외부 클릭 시 닫기
	useEffect(() => {
		if (!showPopup) return;
		const handleClickOutside = (e) => {
			if (popupRef.current && !popupRef.current.contains(e.target)) {
				setShowPopup(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, [showPopup]);

	return <>
		{displayData.map((x) =>
			<div key={x}><Link to={linkPath + '/' + encodeURIComponent(x)}>{x}</Link></div>
		)}
		{remaining > 0 &&
			<div>
				<span style={{ cursor: 'pointer', color: '#e74c3c', textDecoration: 'underline' }} onClick={handleOpen}>+{remaining}</span>
			</div>
		}
		{showPopup && ReactDOM.createPortal(
			<div ref={popupRef} style={{
				position: 'fixed', left: pos.x, top: pos.y, zIndex: 9999,
				background: '#fff', border: '1px solid #ccc', borderRadius: 8,
				boxShadow: '0 4px 16px rgba(0,0,0,0.15)', minWidth: POPUP_WIDTH, maxWidth: 350, maxHeight: POPUP_MAX_HEIGHT,
			}}>
				<div style={{ padding: '8px 12px', background: '#f8f9fa', borderBottom: '1px solid #eee', borderRadius: '8px 8px 0 0', cursor: 'move', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
					onMouseDown={handleDragStart}>
					<strong>{title || '[Undefined]'} ({data.length})</strong>
					<span style={{ cursor: 'pointer', fontSize: 18, lineHeight: 1 }} onClick={() => setShowPopup(false)}>&times;</span>
				</div>
				<div style={{ padding: '8px 12px', overflowY: 'auto', maxHeight: 340 }}>
					{data.map((x) =>
						<div key={x} style={{ padding: '3px 0', borderBottom: '1px solid #f0f0f0' }}>
							<Link to={linkPath + '/' + encodeURIComponent(x)}>{x}</Link>
						</div>
					)}
				</div>
			</div>,
			document.body
		)}
	</>;
};

const RayTable = ({
	user,
	su = false,
	companies,
	title,
	columns,
	css = "",
	dsfilterCount = 0,
	onlytable = false,
	data,
	calllback,
	exheader = [],
	parentData = null,
	options = {
		filterpageoption: {},
		filterDateOptions: [],
		getList: null,
		responseList: [],
		exheader: [],
		useapi: false,
		linkto: '',
		updateCurPage: null,
		updateFilters: null,
		updateSearchKey: null,
		totalitemcount: 0,
		filters: {},
		filterOptions: [],
		isFalse: false,
	},
	apiPath = "",
	addFilter = "",
	rdpage = "",
	match = "",
	clist,
	nowuserfilter = {},
	exportlocalaction = "",
	conSearch = null,
	bulkActionDo = null,
	bulkActions = [],
	extendFilters = [],
	rowSelectCallback,
	checkBoxCallback,
	onClear,
	listtype = "",
	toggle = null,
	toggleval,
	callbackchangeuserfilter = null,
	ufilters,
	showmodel,
	payloadCallback = null,
	headerSlot = null,
	headerSlotRight = null,
	stateKey,
	listStates,
	dispatch,
	isLoading,
}) => {
	// IMP-307: stateKey 가 있으면 Redux 스냅샷으로 목록 상태 복원(checkList 제외). 미지정 시 기존 동작 100% 불변.
	const savedSnapshot = stateKey ? (listStates && listStates[stateKey]) : undefined;

	const [nowData, setNowData] = useState([]);
	const [userfilter, setUserFilter] = useState([]);
	const [nowfilter, setNowFilter] = useState({});
	const [loading, setLoading] = useState(true);
	const showLoadingRow = loading || isLoading === true;
	const [itemPerPage, setItemPerPage] = useState(user.settings ? (user.settings.dashboardtablelistcount || 30) : 30);
	const [allItemCount, setAllItemCount] = useState(options.totalitemcount || 0);
	const [currentPage, setCurrentPage] = useState(savedSnapshot?.currentPage ?? 1);
	const [skey, setSkey] = useState(savedSnapshot?.skey ?? '');
	const [showExportList, setShowExportList] = useState(false);
	const [sort, setSort] = useState(savedSnapshot?.sort ?? (options.defaultSort ? options.defaultSort : ''));
	const [checkList, setCheckList] = useState([]);
	const [sortType, setSortType] = useState(savedSnapshot?.sortType ?? (options.defaultSortType ? options.defaultSortType : -1));
	const [filters, setFilters] = useState(savedSnapshot?.filters ?? (options.filterColumns || []));
	const [datefilters, setDateFilters] = useState(
		savedSnapshot?.datefilters ?? (
			options.filterpageoption ? (
				options.filterpageoption.hasOwnProperty("filterDateOptions") ?
					options.filterpageoption.filterDateOptions : []
			) : []
		)
	);
	const [filterpage, setfilterpage] = useState(savedSnapshot?.filterpage ?? (options.filterpageoption || {}));
	const [exportData, setExportData] = useState({});
	// IMP-446 — Export 컬럼 선택 모달. 선택은 그 실행에만 적용되며 저장하지 않는다(IMP-444 §5.1 규칙 4).
	const [showExportColumnModal, setShowExportColumnModal] = useState(false);
	const [reportOpenUrl, setReportOpenUrl] = useState(null);
	const [exportSelectedNames, setExportSelectedNames] = useState(null);
	const exportRequestedRef = React.useRef(false);
	const [isFirst, setIsFirst] = useState(true);
	const [columnsReady, setColumesReady] = useState(false);
	const titleColName = React.useMemo(() => columns.find(c => c.type === 'TITLE')?.name, [columns]);
	// IMP-444: 렌더 전용 파생값 — visible!==false 만. 서버 조회조건(projects)·Export 목록 등은 columns 원본을 그대로 사용한다.
	const renderColumns = React.useMemo(() => visibleHeaderColumns(columns), [columns]);

	// IMP-446 — 고정 컬럼 계정 분기(head/isFixedColumnExport) 단일 정의. exportData 빌더 effect 와
	// Export 버튼 핸들러가 같은 값을 참조해야 한다(판정 이중화 금지 — CLAUDE.md §6).
	const exportHead = window.location.href.split("/").pop();
	const isFixedColumnExport = (user?.companyId === 'RAY00001' || user?.adminid === 'jeongho.lee') && exportHead === 'AdminServiceList';

	// BUG-159: 최신 data prop 참조 추적(render 시점 갱신). getList 완료 후 성공 dispatch로 data가 바뀌었는지 판별용.
	const latestDataRef = React.useRef(data);
	latestDataRef.current = data;

	// BUG-159: 요청 세대 카운터 — 동시/연속 요청 시 stale 응답이 최신 요청의 로딩을 조기 해제하지 않도록 가드.
	const requestSeqRef = React.useRef(0);

	// IMP-307: 목록 상태 변경 시 Redux 에 스냅샷 저장(checkList 제외). ListStateReducer 는 어떤 조회 effect 의 의존도 아니므로 재조회 루프 없음.
	const listStateReadyRef = React.useRef(false);
	useEffect(() => {
		if (!stateKey) return;            // 미지정 시 저장 안 함
		if (!columnsReady) return;        // 초기 컬럼 준비 전 저장 안 함
		if (!listStateReadyRef.current) { // 마운트 settled 1회 skip(복원/초기 조회 noise 방지)
			listStateReadyRef.current = true;
			return;
		}
		dispatch(ListStateAction.Save(stateKey, {
			filterpage, currentPage, skey, sort, sortType, filters, datefilters,
			// checkList 미저장 — 보존 대상 아님
		}));
	}, [filterpage, currentPage, sort, sortType, skey, filters, datefilters, stateKey, columnsReady, dispatch]);

	useEffect(() => {
		const newCols = [];
		// IMP-446: 체크박스 선택 Export 의 headers 는 모달에서 고른 컬럼(exportSelectedNames)을 따른다.
		// 표시/숨김 판정과 BUTTON/DEALER_MATCH 제외는 selectExportColumns(exportColumns.js) 안에서 이미
		// 처리되므로 여기서 다시 걸러내지 않는다(판정 이중화 금지 — CLAUDE.md §6).
		// 입력은 renderColumns(표시 컬럼)가 아니라 전체 columns — 조회조건(projects)은 아래 별도 effect 에서
		// 전체 columns 를 그대로 유지한다(FR-007).
		// 얕은 복사: 아래 루프가 { ...x, path: newKey } 로 새 객체만 만들 뿐 원소를 mutate 하지 않으므로
		// 충분하다(JSON 깊은 복사는 함수 프로퍼티를 지워 selectExportColumns 결과 재사용을 막는다).
		const nowCols = selectExportColumns(columns, exportSelectedNames).map((c) => ({ ...c }));

		let newDatas;
		if (nowData)
			newDatas = JSON.parse(JSON.stringify(nowData));
		newDatas = Array.isArray(newDatas) ? newDatas : []; // BUG-157: 비배열 가드

		nowCols.map(x => {
			if (x.name.indexOf(".") > 0) {
				const newKey = x.name.replace(".", "");
				const keyarr = x.name.split(".");
				newDatas?.map((y) => {
					try {
						y[newKey] = y[keyarr[0]][keyarr[1]];
					} catch { }
					return y
				})
				// IMP-446: flatten 키는 name 을 덮어쓰지 않고 path 에 담는다. Exports.js exportWorkbook 이
				// header.path||header.name 순으로 찾으므로 동작은 같고, 원본 dotted name 이 남아
				// 컬럼 정의와 대조하기 쉽다(숨김 dotted 컬럼도 후보로 섞여 들어온다).
				// 아래 타입 변환 루프도 dataKey = path||name 으로 같은 키를 쓴다.
				newCols.push({ ...x, path: newKey })
			}
			else {
				newCols.push(x)
			}
		})
		newCols.map(x => {
			// IMP-446: dotted 컬럼은 위에서 flatten 한 키가 path 에 있다 — name 이 아니라 path||name 으로 접근.
			const dataKey = x.path || x.name;
			if (x.type == "DT" || x.type == "DATETIME") {
				newDatas?.map(y => {
					const v = y[dataKey];
					y[dataKey] = (v === '' || v === null || v === undefined) ? '' : moment(v).local().format('YYYY-MM-DD HH:mm:ss');
					return y
				})
			}
			// BUG-153: OPERATOR 도 COMPANY 와 동일하게 companyId→회사명 해석 (체크박스 선택 Export 경로).
			//   IMP-295(/productv2 denormalized) 후 export 빌더가 OPERATOR 미처리로 raw companyId 출력하던 회귀.
			if ((x.type == "COMPANY" || x.type == "OPERATOR") && companies.length > 0) {
				newDatas?.map(y => {
					const cid = companies.filter(n => n.companyId == y[dataKey]);
					if (cid.length > 0) {
						y[dataKey] = cid[0].name
					}
					return y;
				})
			}
			if (x.type == 'ARRAYLIST') {
				newDatas?.map(y => {
					y[dataKey] = y[dataKey]?.toString();
					return y;
				})
			}
		})

		// IMP-446: head/고정 컬럼 판정은 컴포넌트 스코프의 exportHead/isFixedColumnExport 를 그대로 쓴다
		// (effect 와 버튼 핸들러가 같은 값을 참조 — 판정 이중화 금지).
		const head = exportHead;

		let exportExcelData = newDatas?.filter(x => {
			if (checkList.length > 0 && checkList.includes(depVal(x, options.keyCol)))
				return x;
		});

		let col = newCols;

		if (isFixedColumnExport) {
			exportExcelData = exportExcelData.map(x => {
				return (
					{
						// ticketKey: x.ticketKey,
						ticketKey: moment(x.createDate).format("YYYYMMDD"),
						model: x.model,
						option: x.option,
						country: countryName(x.site?.country),
						sn: x.sn,
						install: x.installedDate > 1065398400000 ? 'Y' : 'N',
						installStartDate: x.installedDate > 1065398400000 ? moment(x.installedDate).format("YYYY-MM-DD") : '',
						installConfirmDate: x.installedDate > 1065398400000 ? moment(x.installedDate).format("YYYY-MM-DD") : '',
						claim: x.summary,
						processContents: x.description,
						submitted: x.creator,
						assigned: x.assignee,
						effectiveDate: x?.effectiveDate ? moment(x.effectiveDate).format('YYYY-MM-DD HH:mm:ss') : '',
						closedDate: x?.closedDate > 0 ? moment(x.closedDate).format('YYYY-MM-DD HH:mm:ss') : '',
						modifyDate: '',
						flag: '',
						status: x.status,
						doadim: (x.doa && 'DOA' || x.dim && 'DIM') || '',
						csType: '',
						grade: '',
						deferReason: '',
						partsReplaces: x.replacementsCNT > 0 ? '교체' : '미교체',
						replacedParts: x?.orgReplacement ? [...new Set(x.orgReplacement.map(x => x.title + ((x?.oldsn || x?.newsn) && ' (' + x?.oldsn + ' => ' + x?.newsn + ')')))].toString() : '',
						chargeOrFree: '',
						invalidRecovery: '',
						sitename: x.sitesitename,
					}
				)
			});

			col = [
				{ name: 'ticketKey', label: '고불처ID' },
				{ name: 'model', label: '구분' },
				{ name: 'option', label: 'Option' },
				{ name: 'country', label: '접수국가' },
				{ name: 'sn', label: 'S/N' },
				{ name: 'sitename', label: '치과명' },
				{ name: 'install', label: 'Install' },
				{ name: 'installStartDate', label: '설치시작일' },
				{ name: 'installConfirmDate', label: '설치확정일' },
				{ name: 'claim', label: '고객불만내용' },
				{ name: 'processContents', label: '처리이력' },
				{ name: 'submitted', label: '접수자' },
				{ name: 'assigned', label: '처리자' },
				{ name: 'effectiveDate', label: '발생일' },
				{ name: 'closedDate', label: '완료일' },
				{ name: 'modifyDate', label: 'Modified' },
				{ name: 'flag', label: 'Flag' },
				{ name: 'status', label: 'Status' },
				{ name: 'doadim', label: '초기불량(DOA/DIM)' },
				{ name: 'csType', label: 'CS구분' },
				{ name: 'grade', label: '분류등급' },
				{ name: 'deferReason', label: '보류사유' },
				{ name: 'partsReplaces', label: '부품교체' },
				{ name: 'replacedParts', label: '교체부품' },
				{ name: 'chargeOrFree', label: '유/무상' },
				{ name: 'invalidRecovery', label: '부적합회수' },
			];
		}

		const payload = {
			items: exportExcelData,
			css: "btn btn-secondary m-0",
			filename: head.replace("Admin", "").replace("List", " List") + " - Download - " + moment().format("YYYYMMDDhhmmss"),
			sheettitle: "Sheet",
			headers: col
		};
		setExportData(payload);
		// IMP-446 — 모달 확인으로 들어온 요청이면 state 반영을 기다리지 않고 방금 만든 payload 로 바로
		// 내보낸다(exportData state 를 기다리면 직전 컬럼 구성으로 나가는 레이스가 생긴다).
		if (exportRequestedRef.current) {
			exportRequestedRef.current = false;
			exportWorkbook(payload);
		}
		// F-003(PR #582 R1): checkList 가 deps 에 없으면 행을 체크해도 이 effect 가 재실행되지 않아
		// 마운트 시점의 빈 checkList 로 만들어진 items:[] 가 남는다. 모달 경로는 exportSelectedNames
		// 변경으로 우연히 재실행되지만 고정 컬럼 경로는 exportData state 를 그대로 읽어 0행을 내보냈다.
	}, [nowData, options, exportSelectedNames, checkList]);

	useEffect(() => {
		setUserFilter(ufilters || []);
	}, [ufilters]);

	useEffect(() => {
		let projects = {};
		// IMP-444/FR-007: 의도적으로 전체 columns 사용(renderColumns 아님) — 숨김 컬럼도 서버 조회조건에 포함되어야
		// 상세 링크·Export 가 그 값을 참조할 수 있다. 일괄 치환으로 되돌리지 말 것.
		columns.map(x => projects[x.name] = 1);
		if (listtype == "product")
			projects = { ...projects, dim: 1, doa: 1, isConnected: 1 }
		if (listtype == "producterr")
			projects = { ...projects, dim: 1, doa: 1, isConnected: 1, 'errs._id': 1 }
		if (listtype == "site")
			projects = {
				...projects,
				customerFirstName: 1, customerLastName: 1, address: 1, addressExtra: 1, sns : 1,
				customerEmail: 1, email: 1, hp: 1, tel: 1, fax: 1, customerHp: 1, customerTel: 1, customerFax: 1
			}
		if (listtype == "sitesurvey")
			projects = { ...projects, customerFirstName: 1, customerLastName: 1 }

		if (listtype == "service")
			projects = { ...projects, dim: 1, doa: 1, installedDate: 1, effectiveDate: 1, sites: 1, createDate: 1, closedDate: 1, description: 1 }

		setColumesReady(true);
		setfilterpage({ ...filterpage, projects: projects });
	}, [columns]);

	useEffect(() => {
		console.log(filterpage, showmodel);
		if (options.getList && columnsReady) {
			setLoading(true);
			const seq = ++requestSeqRef.current;
			const dataSnapshot = latestDataRef.current;
			let payload;
			if (toggle && !filterpage.hasOwnProperty("match")) {
				const to = toggle.filter(x => x.code == toggleval);
				payload = options.getList({ ...filterpage, match: to[0].filter });
			} else {
				payloadCallback && payloadCallback(filterpage);
				payload = options.getList(filterpage);
			}
			// BUG-159: getList(fetch) 완료 후 처리.
			// - seq !== 최신: 이 요청은 이후 요청에 의해 밀린 stale 응답 → 무시(최신 요청이 로딩 관리).
			// - 성공(GET_*LIST dispatch로 data 참조 변경): [data] effect(L443~)가 해제 → 여기선 skip(flash 없음).
			// - 비성공(dispatch 없어 data 참조 불변): 여기서 해제(무한 스피너 방지).
			Promise.resolve(payload).then(
				() => {
					if (seq !== requestSeqRef.current) return;
					if (latestDataRef.current === dataSnapshot) setLoading(false);
				},
				() => {
					if (seq !== requestSeqRef.current) return;
					setLoading(false);
				}
			);
		}
	}, [filterpage, showmodel]);

	useEffect(() => {
		setAllItemCount(options.totalitemcount);
	}, [options.totalitemcount]);

	useEffect(() => {
		if (extendFilters.length > 0) {
			setfilterpage({ ...filterpage, extends: extendFilters, page: extendFilters.resetPage ? 1 : filterpage.page });
		}
	}, [extendFilters]);

	useEffect(() => {
		// [모두 지우기]가 이미 이 match 로 조회했으면 중복 조회를 건너뛴다.
		const cleared = clearMatchRef.current;
		if (cleared !== null) {
			clearMatchRef.current = null;
			if (cleared === JSON.stringify(match ?? {})) return;
		}
		if (isFirst)
			return;
		if (options.useapi) {
			setfilterpage({ ...filterpage, match: match, page: 1 });
		}
	}, [match]);

	//addFilter는 일단 companyId로만 하는걸로 한다.
	useEffect(() => {
		if (!addFilter.hasOwnProperty("companyId"))
			return;

		// IMP-307: 복원 등으로 이미 동일 companyId 면 page:1 리셋 방지(트리 복원 onClickItem 과 표 page 보존 충돌 방지)
		if (options.useapi && filterpage.companyId === addFilter.companyId) return;

		if (options.useapi)
			setfilterpage({ ...filterpage, companyId: addFilter.companyId, page: 1 });
		else
			makeDataList();
	}, [addFilter]);

	useEffect(() => {
		setToggle(toggleval);
	}, [toggleval]);

	useEffect(() => {
		const newFilter = [];
		if (!options.filterOptions) return;
		options.filterOptions.map((x) => {
			newFilter.push({
				col: x.name,
				val: x.val || 'ALL',
				options: x.list.map((y) => y._id),
			});
		});

		setFilters(newFilter);
	}, [options.filterOptions]);

	useEffect(() => {
		if (options.useapi) {
			if (isFirst) {
				setIsFirst(false);
			} else {
				setCheckList([]);
				setNowData(Array.isArray(data) ? data : []); // BUG-157: 비배열 가드 (nowData.map 크래시 방지)
				setLoading(false);
			}
		}
	}, [data]);

	useEffect(() => {
		if (!options.useapi) {
			setCheckList([]);
			setLoading(false);
			makeDataList(data);
		}
	}, [data, currentPage, sort, sortType, skey, filters, datefilters]);

	const genUserFilter = (filter) => {
		const mt = {}
		filter.map(x => {
			if (x.type == "STRING")
				mt[x.key] = x.val;
			if (x.type == "DATETIME") {
				mt[x.key] = {};
				if (x.val.opt == "last") {
					mt[x.key]['$gte'] = moment().add(-1 * x.val.lastVal, x.val.lastValOpt).valueOf();
				} else {
					mt[x.key]['$gte'] = x.val.s;
					mt[x.key]['$lte'] = x.val.e;
				}
			}
			if (x.type == "BOOLEAN")
				mt[x.key] = x.val;
		})
		return mt;
	}

	const changeCurPage = (index) => {
		if (options.useapi) {
			updateCurPage(index, skey);
		} else {
			setCurrentPage(index);
		}
	};

	const makeDataList = () => {
		// BUG-157: 비배열 가드 (형제 write 경로, useapi=false 클라이언트 페이지네이션). data 비배열/undefined 시 [...data] TypeError(is not iterable) 방지 — L449 setNowData 가드와 대칭
		let newData = [...(Array.isArray(data) ? data : [])];
		newData = searchData(newData);
		newData = dtfilteredData(newData);
		newData = filteredData(newData);
		newData = addfilteredData(newData);
		setAllItemCount(newData.length);

		// IMP-307: 복원된 page 가 총 페이지수 초과 시 보정(useapi=false 클라이언트 페이지네이션)
		const totalPages = Math.max(1, Math.ceil(newData.length / itemPerPage));
		if (currentPage > totalPages) { setCurrentPage(totalPages); }

		newData.sort((a, b) => (a[sort] > b[sort] ? sortType : sortType * -1));
		setNowData(paginate([...newData]));
	};

	const handleSearch = (e) => {
		const key = e.target.value;
		setSkey(key);
	};

	const handleSearchKeyPress = (e) => {
		if (options.useapi && e.key === 'Enter') updateSearchKey(e.target.value);
	};

	const handleSearchButton = (e) => {
		updateSearchKey(skey)
	};

	const handleDateFilter = (e, code) => {
		const newFilter = [...datefilters];
		newFilter.map(x => {
			if (x.code == code)
				x.val = e
		});

		if (options.useapi) {
			setfilterpage({ ...filterpage, page: 1, filterDateOptions: newFilter });
		} else {
			setDateFilters(newFilter)
		}
	};

	const handleFilter = (e, idx) => {
		const newFilter = [...filters];
		newFilter[idx].val = chkgetTFValue(e.target.value);
		setFilters(newFilter);

		if (options.useapi) {
			const obj = {};
			newFilter.map((x) => {
				x.val == 'ALL' || (obj[x.col] = x.val);
			});
			updateFilters(obj, skey);
		}
	};

	// #570: Clear 버튼. 검색어·드롭다운·날짜 필터·페이지·체크를 처음 상태로(정렬은 유지). 원본 객체를 건드리지 않도록 새 객체로 교체한다.
	// ListStateAction.Clear 는 쓰지 않는다(트리 상태까지 지워짐) — 저장 effect 가 초기화된 값을 다시 저장한다.
	// onClear 가 { match } 를 돌려주면(화면이 상세 검색 조건을 비웠다는 뜻) 그 조건으로 한 번만 조회한다.
	// 화면이 곧 setMatch 로 같은 값을 내려 [match] effect 가 한 번 더 조회하므로, 값이 같으면 그 조회는 건너뛴다.
	const clearMatchRef = React.useRef(null);
	const handleClear = () => {
		// 같은 클릭 안의 setState 는 일괄 처리되므로 onClear 를 먼저 불러도 결과 상태는 같다(뒤따르는 [match] 조회는 clearMatchRef 가 거른다).
		const override = onClear ? onClear() : undefined;
		setSkey('');
		setFilters((Array.isArray(filters) ? filters : []).map(x => ({ ...x, val: 'ALL' })));
		setDateFilters((Array.isArray(datefilters) ? datefilters : []).map(x => {
			const { val, ...rest } = x || {};
			return rest;
		}));
		setNowFilter({});
		setCheckList([]);
		checkBoxCallback && checkBoxCallback([]);
		if (options.useapi) {
			const next = {
				...filterpage,
				page: 1,
				searchKey: '',
				filterDateOptions: [],
				filters: options.filterpageoption?.filters,
			};
			if (override && typeof override === 'object' && Object.prototype.hasOwnProperty.call(override, 'match')) {
				next.match = override.match;
				clearMatchRef.current = JSON.stringify(override.match ?? {});
			}
			setfilterpage(next);
		} else {
			setCurrentPage(1);
		}
	};

	const showClearButton = !!options.showClear && (!!options.search || (filters?.length ?? 0) > 0 || (datefilters?.length ?? 0) > 0);
	// filters.map 안에서는 options 가 지역 배열로 가려지므로 검색칸 유무를 미리 잡아 둔다
	const clearFollowsSearch = !!options.search;
	const searchButton = options.search && options.useapi
		? <button className="btn btn-secondary mt-0" onClick={() => handleSearchButton()}>{t('common.button.search')}</button>
		: null;

	const updateCurPage = (page, search) => {
		setfilterpage({ ...filterpage, page: page, searchKey: search });
	};

	const updateFilters = (filters, search) => {
		setfilterpage({ ...filterpage, page: 1, filters: filters, searchKey: search });
	};

	const updateSearchKey = (search) => {
		setfilterpage({ ...filterpage, page: 1, searchKey: search });
	};

	const updateSortInfo = (sort) => {
		setfilterpage({ ...filterpage, page: 1, sort: sort });
	};

	const setToggle = (val) => {
		if (toggle) {
			const to = toggle.filter(x => x.code == val);
			if (to[0].code != toggleval) {
				setfilterpage({ ...filterpage, match: to[0].filter, page: 1 });
			}
		}
	};

	const addfilteredData = (odata) => {
		let nData = [];
		if (Object.keys(addFilter).length > 0) {
			Object.keys(addFilter).map(key => {
				const k = key;
				const v = addFilter[key];
				if (!v) {
					nData = odata;
					return;
				}
				if (v !== "0") {
					nData = odata.filter(x => x[k] == v);
				} else {
					nData = odata;
				}
			})
			return nData;
		} else {
			return odata;
		}
	};

	const filteredData = (odata) => {
		let nData = [];
		const nFilter = [...filters.filter(x => x.val != "ALL")];

		if (nFilter.length > 0) {
			nData = odata.filter(x => {
				const filterResult = [];
				for (let i = 0; i < nFilter.length; i++) {
					if (Array.isArray(x[nFilter[i].col]))
						filterResult.push(x[nFilter[i].col].includes(nFilter[i].val));
					else
						filterResult.push(x[nFilter[i].col] == nFilter[i].val);
				}
				return filterResult.filter(Boolean).length == nFilter.length;
			})
			return nData;
		} else {
			return odata;
		}
	};

	const dtfilteredData = (odata) => {
		let nData = [];
		let f = false;
		datefilters.map((filter) => {
			if (filter.val) {
				if (filter.val.opt == "latest") {
					f = true;
					nData = odata.filter(item => item[filter.code] > moment.utc(moment().utc()).add(-1 * filter.val.lastVal, filter.val.lastValOpt).unix() * 1000);
				} else if (filter.val.opt == "fixdate") {
					f = true;
					nData = odata.filter(item => item[filter.code] > filter.val.s && item[filter.code] < filter.val.e);
				}
			}
		});

		return f ? nData : odata;
	};

	const paginate = (items) => {
		return items.slice((currentPage - 1) * itemPerPage, currentPage * itemPerPage);
	};

	const searchData = (odata) => {
		let nData = [];
		if (skey.length >= 2) {
			nData = odata.filter(x => {
				let isMatch = false;
				for (let i = 0; i < columns.length; i++) {
					if (x[columns[i].name]) {
						isMatch = x[columns[i].name].toString().toUpperCase().indexOf(skey.toUpperCase()) > -1
						if (isMatch) break;
					}
				}
				return isMatch;
			})
			return nData;
		} else {
			return odata;
		}
	};

	const handleSort = (sortCol) => {
		setSortType(sortType * -1);
		setSort(sortCol);
		if (options.useapi) {
			const obj = {};
			obj[sortCol] = sortType * -1;
			updateSortInfo(obj);
		}
	};

	const isEqaul = (str) => { return str.charAt(str.length - 1) == "e" }

	const minmaxPassFail = (item, col) => {
		const ret = [];
		let passorfail = false;
		let hasminormax = false;
		let alt = "";
		//item[col.min]  = 2;
		//item[col.max] = 30;
		if (!item[col.name])
			return;
		if (item[col.min] && item[col.max]) {
			hasminormax = true;
			passorfail = item[col.name + "pass"] == "Pass";
			if (isEqaul(col.min)) {
				alt = item[col.min] + " <= " + item[col.name] + " <= " + item[col.max];
			} else {
				alt = item[col.min] + " < " + item[col.name] + " < " + item[col.max];
			}
		} else if (item[col.min]) {
			hasminormax = true;
			passorfail = item[col.name + "pass"] == "Pass";
			if (isEqaul(col.min)) {
				alt = "min : " + item[col.min];
			} else {
				alt = "min : " + item[col.min];
			}
		} else if (item[col.max]) {
			hasminormax = true;
			passorfail = item[col.name + "pass"] == "Pass";
			if (isEqaul(col.max)) {
				alt = "max : " + item[col.max];
			} else {
				alt = "max : " + item[col.max];
			}
		}
		if (hasminormax) {
			ret.push(
				<div className="chip chip-media">
					<i className={passorfail ? "chip-icon bg-primary" : "chip-icon bg-danger"}>
						{passorfail && <ion-icon name="checkmark-outline" role="img" className="md hydrated" aria-label="person"></ion-icon>}
						{!passorfail && <ion-icon name="close-outline" role="img" className="md hydrated" aria-label="person"></ion-icon>}
					</i>
					<span title={alt} className="chip-label">{item[col.name]}</span>
				</div>
			)
		} else {
			ret.push(item[col.name])
		}
		return ret;
	};

	const getColGroup = (f, idx) => {
		if (options.useapi) return f.options;
		if (options.groupFilter) {
			if (filters[idx - 1] && filters[idx - 1].val != "ALL") {
				return [
					...new Set(
						data.filter((x) => x[filters[idx - 1].col] == filters[idx - 1].val).map((item) => {
							return item[f.col];
						}, [])
					),
				].sort((a, b) => a > b == -1);
			} else {
				return [
					...new Set(
						data.map((item) => {
							return item[f.col];
						}, [])
					),
				].sort((a, b) => a > b == -1);
			}
		} else {
			return [
				...new Set(
					data.map((item) => {
						return item[f.col];
					}, [])
				),
			].sort((a, b) => a > b == -1);
		}
	};

	const handleCheckBox = (e, key) => {
		const newCheckList = e.target.checked ? [...checkList, key] : checkList.filter((item) => item !== key);
		setCheckList(newCheckList);
		checkBoxCallback && checkBoxCallback(newCheckList);
	};

	const getObjectToString = (data) => Object.keys(data).map(function (key) { return "" + key + "=" + data[key]; }).join(", ")
	const getArrayToString = (data) => {
		const ret = [];
		data.map(x => ret.push(<li className="list-group-item">{getObjectToString(x)}</li>))
		return ret
	}

	const handleCheckBoxAll = (e) => {
		const newCheckList = e.target.checked ? nowData.map((item) => {
			if (options.keyCol.indexOf('.') == -1)
				return item[options.keyCol];
			else
				return item[options.keyCol.split('.')[0]][options.keyCol.split('.')[1]];
		})
			: [];

		setCheckList(newCheckList);
		checkBoxCallback && checkBoxCallback(newCheckList);
	};

	const getItemText = (item, key, col) => {
		const countKeys = ["country", "ticketNationCode"];
		try {
			let r = '';
			if (key.indexOf('.') > -1) {
				const arr = key.split('.');
				r = item[arr[0]][arr[1]];
			} else {
				r = item[key];
			}
			if (col.type == "DT" || col.type == "DATETIME") {
				r = r ? formatDisplayDateTime(r, { fallback: '' }) : "";
			} else if (col.type == 'DTONLY') {
				r = r ? formatDisplayDate(r, { fallback: '' }) : "";
			}
			else if (col.type == "SPAN" && Number.isInteger(parseInt(r))) {
				r = parseInt(r).toLocaleString();// moment.duration(r, "seconds").humanize();
			} else if (col.type == "PROGRESS") {
				r = getProg(item, key, col);
			} else if (col.type == "OPERATOR") {
				if (companies.length > 0) {
					const com = companies.filter(x => x.companyId == r);
					r = com.length > 0 ? com[0].name : r;
				}
			} else if (col.type == "TF" || col.type == "BOOLEAN") {
				r = getTF(r, col);
			} else if (col.name == "summary") {
				// IMP-089 (ev-41): 제목(Link)과 chip 아이콘을 2줄로 분리 — 한 줄에 몰려 가독성 낮은 문제 개선
				const hasChips = item["commentsCNT"] > 0 || item["attachmentsCNT"] > 0 || item["replacementsCNT"] > 0;
				r = <>
					<Link to={"/Admin/AdminService/" + item["ticketKey"]}>{r}</Link>
					{hasChips && <div style={{ marginTop: 3 }}>
						{item["commentsCNT"] > 0 && chip("chatbubble-outline", "primary", item["commentsCNT"])}
						{item["attachmentsCNT"] > 0 && chip("attach-outline", "success", item["attachmentsCNT"])}
						{item["replacementsCNT"] > 0 && chip("construct-outline", "danger", item["replacementsCNT"])}
					</div>}
				</>;
			} else if (col.name == "sn") {
				r = <>{isCon(item, 16)}{r} {isNEW(item, moment.utc(moment().utc()).add(-(-1 * user.settings ? (user.settings.dslatestinstalleddays || 14) : 14), 'days').unix() * 1000)}
					{isDOA(item, user.adminType)} {isDIM(item, user.adminType)} </>;
			} else if (col.type == "SITEFIRSTLAST") {
				r = <>{item["customerFirstName"] + " " + (item["customerLastName"] ? item["customerLastName"] : "")}</>;
			} else if (col.type == "SITEADDR") {
				r = <>{item["address"] + " " + (item["addressExtra"] ? item["addressExtra"] : "")}</>;
			} else if (col.type == "SITEEMAIL") {
				r = <>{item["email"] || item["customerEmail"]}</>;
			} else if (col.type == "STATUS") {
				r = <ServiceStatusChip item={{ status: r }} vertical />;
			} else if (col.type == "TITLE") {
				r = r || "[UNDEFINED]";
			} else if (col.type == "COUNTRY" || (countKeys.includes(key) && r.length == 2)) {
				const cname = CountryCode.find(item => r == item.code).title;
				r = <>
					<OverlayTrigger
						placement={'top'}
						overlay={<Tooltip> {cname} </Tooltip>}
					>
						<img src={"/assets/img/flags/" + r + ".png"} style={{ height: 24 }} alt={cname} />
					</OverlayTrigger>
					{col.showtype != "ONLYFLAG" && <>&nbsp;{cname}</>}
				</>
			}
			return r;
		} catch { }
		return "";
	};

	const chip = (icon, color, count) => {
		return <div className="chip chip-media me-05">
			<div className={"chip-icon bg-" + color}>
				<ion-icon name={icon}></ion-icon>
			</div>
			<span className="chip-label">{count}</span>
		</div>;
	}

	const getTF = (value, col) => {
		const size = {
			width: 24,
			height: 24,
		}
		return <>
			{value && <span className="text-primary"><ion-icon name="checkmark-circle" style={size}></ion-icon></span>}
			{!value && !(col.itemlabel == "reportstatus") && col.tfStyle == "neutral" && <span className="text-secondary"><ion-icon name="ellipse-outline" style={size}></ion-icon></span>}
			{!value && !(col.itemlabel == "reportstatus") && col.tfStyle != "neutral" && <span className="text-danger"><ion-icon name="ellipse" style={size}></ion-icon></span>}
		</>
	}

	const getProg = (item, key, col) => {
		const max = col.max;
		const val = item[key];
		const per = Math.round(val * 100 / max);
		return <div className="progress" style={{ height: 18 }}>
			<div className="progress-bar bg-primary"
				style={{ width: per + "%", height: 18 }}
				aria-valuenow={per}
				aria-valuemin="0" aria-valuemax="100">{item[key]}</div>
		</div>
	}

	const depVal = (item, key) => {
		if (key.indexOf('.') > -1) {

			const arr = key.split('.');
			return item[arr[0]] ? item[arr[0]][arr[1]] : '';
		} else {
			return item[key];
		}
	}

	// 미제출 보고서: 예고 없이 같은 창이 넘어가지 않도록 확인 후 새 창으로 연다 (IMP-475 U-29)
	const goReport = (installationId, modifylink) => {
		if (installationId == null || !modifylink) return;
		setReportOpenUrl(modifylink + installationId);
	}

	const openReport = (url) => {
		if (!url) return;
		const w = window.open(url, '_blank');
		if (!w) {
			dispatch(AlertAction.ErrorMsg(t('product.message.popupBlocked')));
		}
	}

	const getVal = (item, key, coloption) => {
		const col = columns.filter(x => x.name == key)[0];

		let el;

		if (col.name == 'summary') {	// AdminProductServiceList 중 Icon(chip)은 Link에서 제외하기 위해 추가함. 다른 곳에 영향이 있을지 체크 필요 (2022.04.27 LJH)
			el = getItemText(item, key, coloption);
		} else if (options.linkto && Array.isArray(options.linkkey) && options.keyCol == col.name) {
			const linkparam = options.linkkey.map(x => { return depVal(item, x) });
			el = <Link to={options.linkto + "/" + linkparam.join("/")}>{getItemText(item, key, coloption)}</Link>;
		} else if (options.linkto && key == options.linkkey) {
			el = <Link to={options.linkto + "/" + depVal(item, options.keyCol)}>{getItemText(item, key, coloption)}</Link>;
		} else if (col.name == "sn") {
			el = <Link to={"/Admin/AdminProductInfo/" + depVal(item, col.name)}>{getItemText(item, key, coloption)}</Link>;
		} else if (options.linkto && key == options.linkkey) {
			el = <Link to={options.linkto + "/" + depVal(item, options.keyCol)}>{getItemText(item, key, coloption)}</Link>;
		} else if (col.link && depVal(item, col.linkdata)) {
			el = <Link to={col.link + "/" + depVal(item, col.linkdata)}>{getItemText(item, key, coloption)}</Link>;
		} else if (options.linkkey && key == options.linkkey) {
			return <a href onClick={() => rowSelectCallback && rowSelectCallback(item)}>{getItemText(item, key, coloption)}</a>;
		} else if (col.itemlabel == "report") {
			if (item[col.itemview])
				return <Link to={col.itemlink + depVal(item, col.itemlinkkey)}>{getItemText(item, key, coloption)}</Link>;
			else
				return <a href style={{ cursor: 'pointer' }} onClick={() => goReport(depVal(item, col.itemlinkkey), col.modifylink)}>{getItemText(item, key, coloption)}</a>;
		} else {
			el = getItemText(item, key, coloption);
		}

		return el;
	};

	const btnClick = (item, btnOptions) => {
		if (btnOptions.paramType == 'param') {
			history.push({
				pathname: btnOptions.linkPath,
				state: {
					refer: btnOptions.paramRefer,
					item: item,
					extraItem: parentData,
				},
			});
		} else if (btnOptions.paramType == 'callback') {
			calllback && calllback(item);
		}
	};

	const chkgetTFValue = (option) => {
		if (option === "True")
			return true;
		if (option === "False")
			return false;
		return option;
	}

	const chkgetTFOption = (option, type) => {
		if (type === "isSubmit") {
			if (option === true)
				return "Complete";
			if (option === false)
				return "Incomplete";
		} else {
			if (option === true)
				return "True";
			if (option === false)
				return "False";
			if (type == "lang") {
				const nl = LanguageCode.filter(x => x.code == option);
				return nl.length > 0 ? nl[0].title : option;
			}
		}
		return option;
	}

	const countryName = (option) => {
		if (option) {
			const cname = CountryCode.find(x => x.code == option);
			return cname ? cname.title : option;
		}
		return "UNDEFINED";
	}
	// IMP-314: 필터 옵션 표시 라벨(country→countryName, 그 외→chkgetTFOption). 렌더당 1회.
	const optLabel = (col, option) =>
		col == "country" ? countryName(option) : chkgetTFOption(option, col);
	const s_sort = (a, b) => {
		if (a > b) return -1;
		else if (a == b) return 0;
		else return 1;
	}

	const getFilterTitle = (val) => {
		if (val == "isSubmit")
			return "SUBMITTED"
		if (val == "lang")
			return "LANGUAGE"
		return val ? val.toUpperCase() : '';
	}

	const goExport = () => {
		setShowExportList(true);
	}

	// IMP-446 — Export 버튼 클릭. 고정 컬럼 계정 분기(isFixedColumnExport)는 컬럼 선택 대상이 아니다
	// (Spec FR-006) — 기존대로 즉시 내보낸다. 그 외에는 컬럼 선택 모달을 연다.
	const handleExportClick = () => {
		if (isFixedColumnExport) {
			// F-003(PR #582 R1): exportWorkbook 은 items 가 0건이면 경고 없이 return 한다(§7 silent-drop).
			// 버튼을 눌렀는데 아무 일도 안 일어나는 상태를 최소한 관측 가능하게 남긴다.
			if (!exportData?.items?.length) {
				console.warn('[RayTable] fixed-column export skipped — no rows to export', {
					handler: 'handleExportClick',
					caller: user?.adminid || user?.companyId,
					target: exportHead,
					reason: 'exportData.items is empty',
				});
				return;
			}
			exportWorkbook(exportData);
			return;
		}
		setShowExportColumnModal(true);
	}

	const getModelInfo = (val) => {
		const ret = clist.find(x => x.group === val || x.alias.includes(val));
		return ret;
	}

	return (
		<>
			{!showExportList && <>
				{title && <h2>{title}</h2>}
				{!onlytable &&
					<div className="row">
						<div className={(bulkActions.length > 0 && checkList.length > 0) ? "col-4" : "col-4 pt-1"} style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
							{(allItemCount > 0 && !(bulkActions.length > 0 && checkList.length > 0) && !options.hideListCount) && <span className="h3 mb-0">{allItemCount.toLocaleString()}</span>}
							{headerSlot}
							{(bulkActions.length > 0 && checkList.length > 0) && <div className="btn btn-group mt-0 p-0">
								{bulkActions.map(x => <button
									className={x.className || (x.action == "OPTRANSFER" ? "btn btn-success mt-0" : (x.action == "CLEARDOA" ? "btn btn-danger mt-0" : "btn btn-warning mt-0"))}
									onClick={() => bulkActionDo && bulkActionDo(x.action)}>{x.title}{x.action != 'EXPORTCSR' && (checkList.length > 0 && "(" + checkList.length + ")")}</button>
								)}
							</div>}
						</div>
						<div className="col-8 mb-1">
							<div className="float-end">
								<div className="input-group">
									{(conSearch) && <div className="me-1">
										<button
											className={dsfilterCount > 0 ? "btn btn-success m-0" : "btn btn-warning m-0"}
											onClick={(e) => conSearch(e)}>{t('common.label.deepSearch')}{dsfilterCount > 0 ? "(" + dsfilterCount + ")" : ""}</button>
									</div>}
									{datefilters.map((item, idx) => {
										return <InputDateFilter
											key={item.code + idx}
											options={{
												type: "datetime",
												name: item.code,
												onlyDate: true,
												label: item.label,
												val: item.val || {
													opt: "",
													lastVal: 1,
													lastValOpt: "d",
													s: new Date().getTime(),
													e: new Date().getTime(),
												},
												required: true
											}}
											disabled={loading}
											inline={true}
											editable={true}
											onchange={(e) => handleDateFilter(e, item.code)} />
									})}
									{toggle && <div className='me-2'><button
										onClick={() => setToggle(!toggleval)}
										className="btn btn-warning mt-0">
										{toggle.filter(x => x.code == toggleval)[0].title}
									</button></div>
									}
									{su && userfilter.length > 0 && <select
										onChange={(e) => {
											const picked = e.target.value === "" ? {} : userfilter.filter(x => x.id == e.target.value)[0];
											setNowFilter(picked || {});
											callbackchangeuserfilter(picked);
										}}
										value={nowfilter?.id ?? ""}
										className="form-control">
										<option value="">{t('selectafilter')}</option>
										{userfilter.map((option, id) => (
											<option key={id} value={option.id}>{option.title}</option>
										))}
									</select>}
									{headerSlotRight && <div className="me-1">{headerSlotRight}</div>}
									{filters.map((item, idx) => {
										let options = getColGroup(item, idx);

										const tmp = [];

										if (item.col === 'model') {
											if (user?.isMegagen)
												options = ['R2 Studio Q'];

											if (Array.isArray(options[0])) {
												for (let i = 0; i < options.length; i++) {
													for (let j = 0; j < options[i].length; j++) {
														if (!tmp.includes(options[i][j]) && options[i][j] != '')
															tmp.push(options[i][j]);
													}
												}

												options = tmp;
											}
										}

											// IMP-314: 옵션 라벨 앞 nbsp 들여쓰기(FILTER_OPT_INDENT 모듈 상수)로 좌측 여백 확보.
										return (
											<select
												key={idx}
												onChange={(e) => handleFilter(e, idx)}
												value={item.val}
												className={showClearButton && !clearFollowsSearch && idx === filters.length - 1 ? 'form-control rounded-end' : 'form-control'}
											>
												<option value="ALL">{FILTER_OPT_INDENT}{t('common.label.all')}({getFilterTitle(item.col)})</option>
												{item.col != "isSubmit" ?
													options.filter(x => x).sort(s_sort).map((option) => (
														<option key={option} value={option}>
															{FILTER_OPT_INDENT}{optLabel(item.col, option)}
														</option>
													)) : options.sort(s_sort).map((option) => (
														<option key={option} value={option}>
															{FILTER_OPT_INDENT}{optLabel(item.col, option)}
														</option>
													))}
											</select>
										);
									})}
									{options.search && <input
										value={skey}
										onChange={handleSearch}
										onKeyPress={handleSearchKeyPress}
										disabled={loading}
										type="text"
										className={showClearButton ? 'form-control rounded-end' : 'form-control'}
										placeholder={t('common.button.search')}
									/>}
									{/* [모두 지우기]·[검색]은 앞 칸과 띄운 별도 묶음 — 모서리는 앱 버튼 모양을 그대로 따른다 */}
									{showClearButton
										? <div className="input-group flex-nowrap w-auto ms-1">
											<button type="button" className="btn btn-outline-secondary mt-0" disabled={loading} onClick={handleClear}>{t('common.button.clear')}</button>
											{searchButton}
										</div>
										: searchButton}
								</div>
							</div>
						</div>
					</div>}
				<div className={renderColumns.length > 10 ? "overflow-auto" : ""}>
					<table className={css ? css : "table table-bordered mb-1"}>
						<thead>
							<tr>
								{options.isShowCheckBox && (
									<td style={{ width: 24 }}>
										<input
											type="checkbox"
											checked={(nowData?.length ?? 0) > 0 && checkList.length === nowData.length}
											onChange={(e) => handleCheckBoxAll(e)}
										/>
									</td>
								)}
								{renderColumns.map((col) => {
									return (
										<th key={col.name} onClick={() => col.insortable || handleSort(col.name)}
											className={col.align && col.align}
											style={col.style && col.style}
										>
											{col.label}
											{sort == col.name && sortType == 1 && <span>&#8593;</span>}
											{sort == col.name && sortType == -1 && <span>&#8595;</span>}
										</th>
									);
								})}
							</tr>
						</thead>
						<tbody>
							{/* 호출 화면이 isLoading={true} 를 주면 데이터 행·'데이터 없음' 대신 로딩 행만 표시(미지정 시 기존 동작 불변). */}
							{showLoadingRow && <tr><td colSpan={renderColumns.length + (options.isShowCheckBox ? 1 : 0)}><Loading /></td></tr>}
							{!showLoadingRow && nowData?.map((item, index) => {
								return (
									<tr
										key={index}
										className={rowSelectCallback && 'row_hand'}
										onClick={() => rowSelectCallback && rowSelectCallback(item)}
									>
										{options.isShowCheckBox && (
											<td>
												<input
													type="checkbox"
													checked={checkList.includes(depVal(item, options.keyCol))}
													onChange={(e) => {
														handleCheckBox(e, depVal(item, options.keyCol));
													}}
												/>
											</td>
										)}
										{renderColumns.map((col, idx) => {
											if (col.type == 'DEALER_MATCH') {
												const matched = item.dealerMatched;
												const companyName = item.companyName;
												const dealerOriginal = item.dealerOriginal;
												if (matched === true) {
													return (
														<td key={col.name + idx} className="text-center p-0">
															<span className="text-success fw-bold" style={{ fontSize: "12px" }}>{companyName}</span>
														</td>
													);
												} else if (matched === false) {
													return (
														<td key={col.name + idx} className="text-center p-0">
															<button
																className="btn btn-sm btn-danger mt-05 me-1"
																style={{ fontSize: "12px" }}
																onClick={() => btnClick(item, col.options)} >
																Assign
															</button>
															<span className="text-danger" style={{ fontSize: "12px" }}>{dealerOriginal}</span>
														</td>
													);
												} else {
													return (
														<td key={col.name + idx} className="text-center p-0">
															<span className="text-muted" style={{ fontSize: "12px" }}>-</span>
														</td>
													);
												}
											} else if (col.type == 'BUTTON') {
												return (
													<td key={col.name + idx} className="text-center p-0">
														<button
															className="btn btn-sm btn-warning mt-05"
															style={{ fontSize: "12px" }}
															onClick={() => btnClick(item, col.options)} >
															{col.options.title}
														</button>
													</td>
												);
											} else if (col.type == 'MODEL_SET_BUTTON') {
												const cname = item[col.name];
												const prdmodel = getModelInfo(cname);
												return <>
													{prdmodel && <td key={col.name + idx} className="text-center p-0">{prdmodel.name}</td>}
													{!prdmodel && <td key={col.name + idx} className="text-center text-danger fw-bolder p-0">{cname}</td>}
												</>
											} else if (col.type == 'CALLBACK_BUTTON') {
												return (
													<td key={col.name + idx} className="text-center p-0">
														<button
															className="btn btn-sm btn-warning mt-05"
															style={{ fontSize: "12px" }}
															onClick={() => btnClick(item, col.options)} >
															{getVal(item, col.name, col)}
														</button>
													</td>
												);
											} else if (col.type == 'CALLBACK_ICON') {
												const v = depVal(item, col.name);
												return (
													<td key={col.name + idx} className="text-center p-0">
														<a href onClick={(e) => { e.preventDefault(); btnClick(item, col.options); }} title={col.options?.title || ''} style={{ cursor: 'pointer' }}>
															{v && <span className="text-primary"><ion-icon name="checkmark-circle" style={{ width: 24, height: 24 }}></ion-icon></span>}
															{!v && <span className="text-secondary"><ion-icon name="ellipse-outline" style={{ width: 24, height: 24 }}></ion-icon></span>}
														</a>
													</td>
												);
											} else if (col.type == 'COMPANY') {
												let cname = item[col.name];
												if (companies.length > 0) {
													const cid = companies.filter(x => x.companyId == cname);
													if (cid.length > 0)
														cname = cid[0].name
												}
												return (
													<td className="" key={col.name + idx}>
														{cname}
													</td>
												)
											} else if (col.type == 'EMSLOGBUTTON') {
												return (
													<td className="text-center p-0" key={col.name + idx}>
														<EMSLogButton item={item} col={col} css={"btn btn-sm btn-success mt-05"} product={parentData} showtextfilename={true} />
													</td>
												)
											} else if (col.type == 'PASSFAIL') {
												return (
													<td className="text-center p-0" key={col.name + idx}>
														{minmaxPassFail(item, col)}
													</td>
												)
											} else if (col.type == 'LIST') {
												return (
													<td className="text-left p-0" key={col.name + idx}>
														<ul className="list-group list-group-flush">
															{getArrayToString(item[col.name])}
														</ul>
													</td>
												)
											} else if (col.type == 'TAG') {
												return (
													<td key={col.name + idx} className={col.align && col.align}>
														{item[col.name]?.map(x =>
															<div className="chip chip-outline me-05">
																<span className='chip-label'>{x}</span>
															</div>
														)}
													</td>
												)
											} else if (col.type == "LISTTABLE") {
												return (
													<td key={col.name + idx} className="text-center p-0">
														{
															item[col.name]
														}
														{
															item[col.name].map(x => {
																if (col.itemlink && col.itemlinkkey) {
																	return <Link to={col.itemlink + x[col.itemlinkkey]}>{x[col.itemlinkkey]}</Link>
																} else {
																	return x[col.itemlabel]
																}
															})
														}
													</td>
												);
											} else if (col.type == "ARRAYLIST") {
												return (
													<td key={col.name + idx} className="text-center p-0" style={{ whiteSpace: 'pre-wrap' }}>
														{
															item[col.name].map(x => x)
														}

													</td>
												);
											} else if (col.type == "ARRAYLINK") {
												return (
													<td className="text-center pt-1" key={col.name + idx}>
														<ArrayLinkCell data={item[col.name] || []} linkPath={col.arraylink} maxShow={col.maxShow || 5} title={item[titleColName] || item.sitename || item.name} />
													</td>
												)
											} else if (col.type == "ARRAY") {
												return (
													<td className="text-center pt-1" key={col.name + idx}>
														{item[col.name]?.map(x => x).join(', ')}
													</td>
												)
											}
											else if (Array.isArray(item[col.name])) {
												return (
													<td key={col.name + idx} className="text-center p-0">
														{item[col.name].slice(0, 1).map(x => {
															if (col.itemlink && col.itemlinkkey) {
																return <Link to={col.itemlink + x[col.itemlinkkey]}>{x[col.itemlinkkey]}</Link>
															} else {
																return x[col.itemlabel]
															}
														})}
														{item[col.name].length > 1 && <span className="badge badge-primary">{item[col.name].length}</span>}
													</td>
												);
											} else if (col.type == 'DOWNLOADBUTTON') {
												return (<td key={col.name + idx} className="text-center p-0">
													{(item.attachmentPath && item.attachmentOrigin) && <S3DownloadButton
														text="Download"
														showtextfilename={true}
														style={{ fontSize: "20px" }}
														path={item.attachmentPath}
														filename={item.attachmentOrigin}
														directLink={item.attachmentDirectLink}
														css={"btn btn-sm btn-success mt-05"}
													/>}
												</td>)
											} else if (col.type == 'INFO') {
												return <td className="text-break" key={col.name + idx}>{getVal(item, col.name, col)}</td>;
											} else if (col.type == 'DOADIM') {
												return (
													<td className="text-break" key={col.name + idx}>{
														item[col.name] &&
														<span className={`badge badge-${col.name == 'doa' && 'danger' || col.name == 'dim' && 'warning'}`}>{col.label}</span>
													}</td>
												)
											} else if (col.type == 'PRDTYPE') {
												return (
													<td key={col.name + idx} className="text-center p-0">
														{item[col.name] === "5d" && <span className="badge badge-primary">{item[col.name].toUpperCase()}</span>}
														{item[col.name] === "expert" && <span className="badge badge-success">{item[col.name].toUpperCase()}</span>}
													</td>
												);
											} else if (col.type == 'PRIORITY') {
												const priority = item[col.name];
												const ICONS = { URGENT: '🔴', FAVORITE: '⭐', NORMAL: '🟢' };
												const LABELS = { URGENT: t('common.status.urgent'), FAVORITE: t('common.status.favorite'), NORMAL: t('common.status.normal') };
												const editable = col.options && col.options.editable;
												const tooltip = priority ? (LABELS[priority] || priority) : '-';
												return (
													<td key={col.name + idx} className="text-center" style={{ width: '60px' }}>
														{editable ? (
															<select
																value={priority || ''}
																title={tooltip}
																onChange={e => col.options.func && col.options.func(item, e.target.value)}
																style={{ border: 'none', background: 'transparent', cursor: 'pointer', appearance: 'none', WebkitAppearance: 'none', MozAppearance: 'none', display: 'block', margin: '0 auto', textAlign: 'center' }}
															>
																											<option value="">-</option>
																<option value="URGENT">🔴</option>
																<option value="FAVORITE">⭐</option>
																<option value="NORMAL">🟢</option>
															</select>
														) : (
															<span title={tooltip}>{priority ? (ICONS[priority] || '-') : '-'}</span>
														)}
													</td>
												);
											} else if (col.type == 'LASTCOMMENT') {
												const lc = item.lastComment;
												return (
													<td key={col.name + idx} style={{ maxWidth: '200px', overflow: 'hidden' }}>
														{lc && lc.comment ? (
															<span
																title={lc.comment}
																style={{ fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block' }}
															>
																{lc.comment}
															</span>
														) : '-'}
													</td>
												);
											}
											else {
												return <td key={col.name + idx} className={`text-break ${col.align && col.align}`}>{getVal(item, col.name, col)}</td>;
											}
										})}
									</tr>
								);
							})}
							{!showLoadingRow && nowData?.length == 0 && <tr><td colSpan={renderColumns.length + (options.isShowCheckBox ? 1 : 0)} className="text-center"><i>{t('common.message.noDataAvailable')}</i></td></tr>}
						</tbody>
					</table>
				</div>
				<div className="row">
					<div className="col ps-1">
						{!showLoadingRow && allItemCount > itemPerPage && (
							<RayPagination
								pageSize={itemPerPage}
								totalItems={allItemCount}
								curPage={rdpage || (options.useapi ? filterpage.page : currentPage)}
								paginate={changeCurPage}
							></RayPagination>
						)}
					</div>
					<div className="col pe-1 text-end">
						{exportlocalaction &&
							(
								checkList.length == 0 ? <button type='button' className={"btn btn-sm btn-secondary rayexport m-0"} disabled={true}>{t('common.button.export')}</button> :
									// IMP-446: 즉시 다운로드 대신 컬럼 선택 모달을 연다(고정 컬럼 계정 분기 제외 — handleExportClick 참조).
									<button
										type="button"
										className={"btn btn-lg btn-primary rayexport m-0"}
										disabled={loading}
										onClick={handleExportClick}>
										{t('common.button.export')}
									</button>
							)
						}
					</div>
				</div>
			</>}
			{showExportList && <RayTableExport
				filters={filterpage}
				sort={sort}
				columns={columns}
				goback={() => setShowExportList()}
				exportlocalaction={exportlocalaction} />}
			{/* IMP-446: columns 는 전체 배열 그대로 전달 — 표시/숨김 판정은 ExportColumnModal 내부(exportColumns.js)가 한다. */}
			<ExportColumnModal
				showModal={showExportColumnModal}
				columns={columns}
				callbackClose={() => setShowExportColumnModal(false)}
				callbackConfirm={(names) => {
					exportRequestedRef.current = true;
					setExportSelectedNames(names);
					setShowExportColumnModal(false);
				}} />
			{reportOpenUrl && <ConfirmDialog
				show={true}
				onClose={() => setReportOpenUrl(null)}
				onConfirm={() => openReport(reportOpenUrl)}
				title={t('installation.message.unsubmittedReportTitle')}
				message={t('installation.message.unsubmittedReportOpenNewWindow')}
				confirmLabel={t('installation.button.openNewWindow')}
				confirmCss="btn btn-block btn-primary" />}
		</>
	);
};

const mapState = (state) => {
	const user = state.AuthReducer.user;
	const su = state.AuthReducer.su;
	const companies = state.CompanyReducer.companies;
	const showmodel = state.ProgramReducer.showmodel;
	const clist = state.RayCodeReducer.items;
	const listStates = state.ListStateReducer;
	return { user, companies, su, showmodel, clist, listStates };
}

export default connect(mapState)(RayTable);
